import createImage from './create-image'
import getRadianAngle from './get-radian-angle'
import rotateSize from './rotate-size'

interface FlipParams {
  horizontal: boolean
  vertical: boolean
}

interface PixelCropParams {
  x: number
  y: number
  width: number
  height: number
}

interface GetCroppedImgParams {
  imageSrc: string
  pixelCrop: PixelCropParams
  rotation?: number
  flip?: FlipParams
}

interface CroppedImg {
  file: Blob
  url: string
}

const getCroppedImg = async ({
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false },
}: GetCroppedImgParams): Promise<CroppedImg | null> => {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    return null
  }

  const rotRad = getRadianAngle(rotation)

  const { width: bBoxWidth, height: bBoxHeight } = rotateSize({
    height: image.height,
    width: image.width,
    rotation,
  })

  canvas.width = bBoxWidth
  canvas.height = bBoxHeight

  ctx.translate(bBoxWidth / 2, bBoxHeight / 2)
  ctx.rotate(rotRad)
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1)
  ctx.translate(-image.width / 2, -image.height / 2)

  ctx.drawImage(image, 0, 0)

  const data = ctx.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height)

  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  ctx.putImageData(data, 0, 0)

  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => resolve({ file: file!, url: URL.createObjectURL(file!) }), 'image/jpeg')
  })
}

export default getCroppedImg
